import { hasLocizeTranslation } from 'lib/utils/locize'

const messages = {
  gallery: ['Product photos and videos', 'รูปภาพและวิดีโอสินค้า'],
  photo: ['Photo', 'รูปภาพ'],
  video: ['Video', 'วิดีโอ'],
  previous: ['Previous image', 'รูปก่อนหน้า'],
  next: ['Next image', 'รูปถัดไป'],
  enlarge: ['Enlarge image', 'ขยายรูปภาพ'],
  close: ['Close image viewer', 'ปิดรูปภาพ'],
  zoomIn: ['Zoom in', 'ขยาย'],
  zoomOut: ['Zoom out', 'ย่อ'],
  reset: ['Reset zoom', 'รีเซ็ตการขยาย'],
  zoomHint: [
    'Pinch or double-tap to zoom',
    'ใช้สองนิ้วหรือแตะสองครั้งเพื่อขยาย',
  ],
  panHint: ['Drag to explore the image', 'ลากเพื่อดูรูปภาพ'],
  unavailable: ['Image could not load', 'ไม่สามารถโหลดรูปภาพได้'],
  retry: ['Try again', 'ลองอีกครั้ง'],
}

export default (t, language, key) =>
  hasLocizeTranslation(
    t,
    `PDP_GALLERY_${key.toUpperCase()}`,
    messages[key][language === 'th' ? 1 : 0],
  )
